(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';
        var TrackingScriptName = 'MoosendTracking';

        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("moosendtracking", TrackingModel);

        if (!Tracker || !Tracker.Properties.MoosendTrackingId)
            return;

        var cookieType = Tracker.CookieGroupCode ? Tracker.CookieGroupCode : '';
        var CanTrack = LhApp.Function.Tracking.canTrack(cookieType);

        var _cartAddResponses = []; // holds a response for every cart add action. 
        var _isUserSelectedProduct;

        Init();

        function LoadImages(skuIds) {

            // Return a new promise.
            return new Promise(function (resolve, reject) {
                var request = { 'skuIds': skuIds.sort().join(',') };
                if (Tracker.Properties.MoosendPhotoImageTypeCode)
                    request.photoImgTypeCode = Tracker.Properties.MoosendPhotoImageTypeCode;
                if (Tracker.Properties.MoosendGalleryImageTypeCode)
                    request.galleryImgTypeCode = Tracker.Properties.MoosendGalleryImageTypeCode;

                $.ajax({
                    url: '/CachedServices/api/affiliates/GetSkuFeedImage',
                    data: request,
                    async: false,
                    success: function (response) {
                        var images = {};
                        for (var s in skuIds) {
                            var skuId = skuIds[s];
                            if (response && response.success && response.data && response.data.hasOwnProperty(skuId) && response.data[skuId])
                                images[skuId] = GetItemUrl(response.data[skuId]);
                            else
                                images[skuId] = '';
                        }
                        resolve(images);
                    },
                    error: function (response) {
                        reject(Error(response.statusText));
                    }
                });
            });
        }

        function GetImageSrc(path) {
            var regEx = new RegExp(Tracker.Properties.ImageSrcReplaceRegex || '(-list\.jpg\?|thumb\.jpg\?)', "ig");
            var image = (path || '').replace(regEx, Tracker.Properties.ImageSrcReplaceWith || 'enlarge');

            if (!image)
                return '';

            var a = document.createElement("a");
            a.href = image;

            if (path.toLowerCase().indexOf(a.hostname.toLowerCase()) == 0)
                a.href = window.location.protocol + '//' + path;

            return a.href;
        }

        function GetItemUrl(path) {
            if (!path)
                return '';

            var a = document.createElement("a");
            a.href = path;

            if (path.toLowerCase().indexOf(a.hostname.toLowerCase()) == 0)
                a.href = window.location.protocol + '//' + path;

            return a.href;
        }

        function Init() {

            if (!CanTrack) return;

            //include moosend script
            !function (t, n, e, o, a) {
                function d(t) {
                    var n = ~~(Date.now() / 3e5), o = document.createElement(e);
                    o.async = !0, o.src = t + '?ts=' + n;
                    var a = document.getElementsByTagName(e)[0]; a.parentNode.insertBefore(o, a)
                } t.MooTrackerObject = a, t[a] = t[a] || function () { return t[a].q ? void t[a].q.push(arguments) : void (t[a].q = [arguments]) }, window.attachEvent ? window.attachEvent('onload', d.bind(this, o)) : window.addEventListener('load', d.bind(this, o), !1)
            }(window, document, 'script', '//cdn.stat-track.com/statics/moosend-tracking.min.js', 'mootrack');
            mootrack('init', Tracker.Properties.MoosendTrackingId);

            //TRACK order completion
            if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {
                if (TrackingModel.Order.IsAlreadyTracked)
                    return;

                if (typeof angular !== 'undefined') {
                    angular.element(document).ready(function () {
                        var oScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();
                        var tracked = false;
                        if (oScope && !tracked) {
                            tracked = true;

                            var checkoutEmail = oScope.Model.Data.Profile.Email.trim().toLowerCase();

                            if (checkoutEmail) {
                                mootrack('identify', checkoutEmail);
                            }

                            //track page view
                            mootrack('trackPageView');

                            var skuIds = TrackingModel.CartProductsData.map(function (i) {
                                return i.SkuId;
                            }).filter(function (value, index, self) {
                                return self.indexOf(value) == index;
                            });

                            var products = TrackingModel.CartProductsData.map(function (product) {

                                return {
                                    itemCode: LhApp.Function.Tracking.getFeedItemId(product, null, Tracker),
                                    itemName: product.Name,
                                    itemImage: !!product && !!product.FeedImage && typeof product.FeedImage === 'string' ? product.FeedImage.startsWith('//') ? "".concat(LhApp.Context.Request.IsSecure ? 'https' : 'http', ":").concat(product.FeedImage) : product.FeedImage : undefined,
                                    itemPrice: product.PriceN,
                                    itemUrl: GetItemUrl(product.Url),
                                    itemTotalPrice: product.PriceN * product.Quantity,
                                    itemQuantity: product.Quantity,
                                    itemCategory: product.Category,
                                    itemManufacturer: product.Brand || ''
                                };

                            });

                            mootrack('trackOrderCompleted', products);
                        }
                    });
                }
            }
        }

        // IMPORTANT execute this scripts in all other pages except checout
        if (typeof (Vendd) != "undefined" && Vendd.Scripts) {

            //On consents update, re-initialize this tracker
            Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertAllCookiesSuccess, TrackingScriptName, function () {
                CanTrack = LhApp.Function.Tracking.canTrack(cookieType);
                Init();
            });
            
            //HELPER this script keep track of products added to cart
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Add, TrackingScriptName, function (envelope) {

                if (!CanTrack) return;

                _cartAddResponses.push({
                    ProductId: envelope.message.data.id,
                    SkuId: envelope.message.data.skuId,
                    Quantity: parseFloat(envelope.message.data.qty)
                });

            });
            
            //TRACK add to cart (recorded by the ABOVE script)
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                var cartModel = envelope.message.data.Cart;

                var pAddResponse = _cartAddResponses.shift();

                (function AddToCartTrack(p) {
                    if (!p)
                        return;

                    var pCartItemModel = cartModel.Items.filter(function (i) {
                        return i.ProductId == p.ProductId && i.VariantId == p.SkuId;
                    });

                    if (pCartItemModel) {
                        var product = pCartItemModel[0];
                        var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                        var trackP = {
                            itemCode: productId,
                            itemName: product.Title || product.Name,
                            itemImage: !!product && !!product.FeedImage && typeof product.FeedImage === 'string' ? product.FeedImage.startsWith('//') ? "".concat(LhApp.Context.Request.IsSecure ? 'https' : 'http', ":").concat(product.FeedImage) : product.FeedImage : undefined,
                            itemPrice: product.Prices.PriceN,
                            itemUrl: GetItemUrl(product.Url),
                            itemQuantity: product.Quantity,
                            itemTotalPrice: product.Quantity * product.Prices.PriceN,
                            itemCategory: product.Category,
                            itemManufacturer: product.ManufacturerName || ''
                        };

                        mootrack('trackAddToOrder', trackP.itemCode, trackP.itemPrice, trackP.itemUrl, trackP.itemQuantity, trackP.itemTotalPrice, trackP.itemName, trackP.itemImage);

                    }

                    AddToCartTrack(_cartAddResponses.shift());

                })(pAddResponse);

            });
            
            //in the case of moosend we first have to retrive user email before sending trcking info
            Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, TrackingScriptName, function (envelope) {

                if (!CanTrack) return;

                if (envelope && envelope.message && envelope.message.data && envelope.message.data.model) {
                    var model = envelope.message.data.model;

                    if (model.IsAuthenticated && model.Email) {
                        mootrack('identify', model.Email);
                    }

                    //track page view
                    mootrack('trackPageView');

                    if (TrackingModel.IsProductListPage) {

                        var skuIds = flatten(toArray(TrackingModel.ProductListsData)).map(function (i) {
                            return i.SkuId;
                        }).filter(function (value, index, self) {
                            return self.indexOf(value) == index;
                        });

                        if (skuIds.length == 0) {

                            return;

                        }

                        var products = [];

                        for (var list in TrackingModel.ProductListsData) {

                            var listItems = TrackingModel.ProductListsData[list];

                            for (var i = 0; i < listItems.length; i++) {
                                var product = listItems[i];
                                var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                                var trackProduct = {
                                    itemCode: productId,
                                    itemName: product.Name,
                                    itemImage: !!product && !!product.FeedImage && typeof product.FeedImage === 'string' ? product.FeedImage.startsWith('//') ? "".concat(LhApp.Context.Request.IsSecure ? 'https' : 'http', ":").concat(product.FeedImage) : product.FeedImage : undefined,
                                    itemPrice: product.PriceN,
                                    itemUrl: GetItemUrl(product.Url),
                                    itemCategory: product.Category,
                                    itemManufacturer: product.ManufacturerName || ''
                                };

                                if (products.filter(function (i) { return i.itemCode === productId }).length <= 0) {

                                    products.push(trackProduct);

                                }

                            };
                        }

                        mootrack('PAGE_VIEWED', products);

                    } else if (TrackingModel.IsProductDetailsPage && TrackingModel.ProductData && TrackingModel.ProductData.length > 0) {

                        var product = TrackingModel.ProductData[0];

                        var trackProduct = {
                            itemCode: LhApp.Function.Tracking.getFeedItemId(product, null, Tracker),
                            itemName: product.Name,
                            itemImage: !!product && !!product.FeedImage && typeof product.FeedImage === 'string' ? product.FeedImage.startsWith('//') ? "".concat(LhApp.Context.Request.IsSecure ? 'https' : 'http', ":").concat(product.FeedImage) : product.FeedImage : undefined,
                            itemPrice: product.PriceN,
                            itemUrl: GetItemUrl(product.Url),
                            itemCategory: product.Category,
                            itemManufacturer: product.ManufacturerName || ''
                        };

                        mootrack('PAGE_VIEWED', [trackProduct]);
                    }
                }
            });

            Vendd.MessageBus.subscribe(Vendd.Product.Messages.SetSelected, TrackingScriptName, function (envelope) {
                //determine if this has been auto raised during product details load in order to avoid tracking twice the product view
                _isUserSelectedProduct = envelope.message.data.visitorInitiated;
            });

            //TRACK product view (changed)
            Vendd.MessageBus.subscribe(Vendd.Product.Messages.Changed, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                if (!_isUserSelectedProduct)
                    return;

                var model = envelope.message.data.model;

                var product = model;
                var productId = LhApp.Function.Tracking.getFeedItemId(product, 'ProductChanged', Tracker);

                var url = window.location.href;
                if (TrackingModel.ProductData && TrackingModel.ProductData.length > 0)
                    url = TrackingModel.ProductData[0].Url;

                var trackProduct = {
                    itemCode: productId,
                    itemName: product.Name,
                    itemImage: !!product && !!product.FeedImage && typeof product.FeedImage === 'string' ? product.FeedImage.startsWith('//') ? "".concat(LhApp.Context.Request.IsSecure ? 'https' : 'http', ":").concat(product.FeedImage) : product.FeedImage : undefined,
                    itemPrice: product.Prices.UnitPriceN,
                    itemUrl: GetItemUrl(url),
                    itemCategory: product.Category,
                    itemManufacturer: product.ManufacturerName || ''
                };

                mootrack('PAGE_VIEWED', [trackProduct]);
            });

        }
    });
})();
